import type { RadioGroupOption, RadioGroupsState } from './cost-to-build-client-ui-radio-groups.types';

export const RADIO_GROUPS_INITIAL_STATE: RadioGroupsState = {
    name: '',
    options: [],
    value: '',
};

const areOptionsEqual = (left: readonly RadioGroupOption[], right: readonly RadioGroupOption[]) => {
    if (left === right) {
        return true;
    }

    if (left.length !== right.length) {
        return false;
    }

    return left.every((option, index) => {
        const other = right[index];
        return (
            option.ariaLabel === other.ariaLabel &&
            option.checked === other.checked &&
            option.disabled === other.disabled &&
            option.id === other.id &&
            option.label === other.label &&
            option.value === other.value
        );
    });
};

export const areRadioGroupsStatesEqual = (left: RadioGroupsState, right: RadioGroupsState) =>
    left.name === right.name && left.value === right.value && areOptionsEqual(left.options, right.options);
